module.exports = __webpack_public_path__ + "static/street-nyc-47b6798a3ce8837af65bfd1b473cc39c.png";